import { colors } from '@material-ui/core';

const obj = {
  root: {
    backgroundColor: colors.grey[50]
  }
};

export default obj;